module.exports = __webpack_public_path__ + "img/refresh_black_24dp.9f70c7f6.svg";